import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const SPRING_ACTIVITY_ROUTES: Routes = [
  {
    path: 'registration',
    loadComponent: () => import('./activity-registration/activity-registration.component').then(m => m.ActivityRegistrationComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'entry',
    loadComponent: () => import('./spring-activity-entry/spring-activity-entry.component').then(m => m.SpringActivityEntryComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'vote',
    loadComponent: () => import('./spring-activity-vote/spring-activity-vote.component').then(m => m.SpringActivityVoteComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'self-registration',
    loadComponent: () => import('./activity-self-registration/activity-self-registration.component').then(m => m.ActivitySelfRegistrationComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'registration/:year',
    loadComponent: () => import('./activity-registration/activity-registration.component').then(m => m.ActivityRegistrationComponent),
    canActivate: [AuthGuard], data: { requireSignIn: false }
  },
  {
    path: 'statistics',
    loadComponent: () => import('./spring-activity-statistics/spring-activity-statistics.component').then(m => m.SpringActivityStatisticsComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'insurance-list',
    loadComponent: () => import('./activity-insurance-list/activity-insurance-list.component').then(m => m.ActivityInsuranceListComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'sign-in-admin',
    loadComponent: () => import('./activity-sign-in-admin/activity-sign-in-admin.component').then(m => m.ActivitySignInAdminComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'trip-options-admin',
    loadComponent: () => import('./spring-activity-trip-options-admin/spring-activity-trip-options-admin.component').then(m => m.SpringActivityTripOptionsAdminComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'audit-log',
    loadComponent: () => import('./spring-activity-audit-log/spring-activity-audit-log.component').then(m => m.SpringActivityAuditLogComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  },
  {
    path: 'backup-browser',
    loadComponent: () => import('./spring-activity-backup-browser/spring-activity-backup-browser.component').then(m => m.SpringActivityBackupBrowserComponent),
    canActivate: [AuthGuard], data: { requireSignIn: true }
  }
];
